import { render, staticRenderFns } from "./proposals-entry.vue?vue&type=template&id=407757ce&scoped=true&"
import script from "./proposals-entry.vue?vue&type=script&lang=js&"
export * from "./proposals-entry.vue?vue&type=script&lang=js&"
import style0 from "./proposals-entry.vue?vue&type=style&index=0&id=407757ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407757ce",
  null
  
)

export default component.exports